module.exports = __webpack_public_path__ + "static/img/touxiang.b5a4e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/touxiang.png
// module id = HlNJ
// module chunks = 1